export default (routes) => {
  const fallbackRoute = routes.find((route) => route.node === '/fallback')
  return (
    (fallbackRoute && routes.find((route) => route.node === fallbackRoute.redirect)) ||
    routes.find((route) => route.node === '/index') ||
    routes.find((route) => route.node === '/')
  )
}
